import React, { type FC } from 'react';
import { Radio, Space, Text } from '@g2u/ui-kit';
// import { Badge } from 'antd';

import { AccountType, PricingCategory, type JsonDataItem, type WithOptionalDataTest } from 'types';
import { useText } from 'helpers/hooks/useText';
import { Section } from 'components';
import styles from './account-type-fields.module.scss';

export namespace AccountTypeFields {
  export type Props = {
    title?: string;
    hasScript?: boolean;
    inline?: boolean;
    customer: JsonDataItem | null;
    initialValues?: JsonDataItem;
  } & WithOptionalDataTest;

  export const $: FC<Props> = (props) => {
    const { inline, customer, title, hasScript, initialValues } = props;
    const { getText } = useText();

    return (
      // <Badge.Ribbon text="Independent account">  TODO: impelemnt with parent account functionality
      <Section.$ title={title ?? 'Account Details'} inline={inline}>
        <Space.$
          direction={Space.Direction.Vertical}
          size={Space.Size.Middle}
          className={styles.accountType__formItem_horizontal}
        >
          {hasScript && <Text.$ className='script-box' mark>{getText('booking.location.visitLocation')}</Text.$>}
          <Radio.$
            required
            dataTestId="account-type-radio"
            initialValue={
              initialValues?.accountType || (customer?.type === 'Company' ? AccountType.Company : AccountType.Personal)
            }
            label="Account Type: "
            name="accountType"
            options={[
              {
                label: <>Personal</>,
                value: AccountType.Personal,
              },
              {
                label: <>Company</>,
                value: AccountType.Company,
              },
            ]}
            rules={[{ required: true }]}
          />
          <Radio.$
            required
            dataTestId="pricing-category-radio"
            initialValue={initialValues?.pricingCategory || customer?.customer_type || undefined}
            label="Pricing Category: "
            name="pricingCategory"
            options={[
              {
                label: <>Home</>,
                value: PricingCategory.Home,
              },
              {
                label: <>Business</>,
                value: PricingCategory.Business,
              },
            ]}
            rules={[{ required: true }]}
          />
        </Space.$>
      </Section.$>
      // </Badge.Ribbon>
    );
  };
}
